<template>
  <header>
    <div v-for="type in ['mobile', 'desktop']" :key="type" :class="`${type}-menu`">
      <WdsStack direction="row" class="menu collapsed-menu-toggle" align-center>
        <a href="/" aria-label="Home link">
          <WdsIcon :size="26" name="worksome"></WdsIcon>
        </a>
        <WdsMenu v-if="notificationCount > 0" manual-trigger>
          <template #trigger="{ toggle }">
            <WdsButtonGhost
              rounded
              aria-controls="notifications"
              :aria-expanded="false"
              aria-label="Notifications"
              class="menu-button"
              @click="toggle"
            >
              <WdsBadge
                float
                :count="notificationCount"
                class="tw-flex tw-items-center tw-justify-center"
              >
                <template #badge-subject>
                  <WdsIcon name="notifications" :size="20"></WdsIcon>
                </template>
              </WdsBadge>
            </WdsButtonGhost>
          </template>
          <div class="app-notifications list-group him-notification">
            <div class="lg-header">
              {{ $t('Notifications') }}
              <ul class="actions">
                <li class="dropdown">
                  <a href="#" data-ma-action="clear-notification" class="m-r-10 m-t-10">
                    <i class="zmdi zmdi-check-all"></i>
                  </a>
                </li>
              </ul>
            </div>
            <ProvideApiFetch
              v-slot="{ loading, results }"
              endpoint="/notificationfeed"
              key-name="notifications"
              fetch-html
            >
              <div style="max-height: 400px; width: 320px; overflow: auto">
                <div
                  v-if="loading || !results?.[0]?.data.length"
                  class="text-center p-20 c-gray-900"
                >
                  <small v-if="loading">@lang('Loading')</small>
                  <small v-if="!loading && !results?.[0]?.data.length">
                    {{ $t('No new notifications') }}
                  </small>
                </div>
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div v-if="!loading" class="lg-body" v-html="results?.[0]?.data"></div>
              </div>
              <a
                v-if="!loading && results?.[0]?.data.length"
                class="view-more"
                href="/notifications"
              >
                {{ $t('View earlier') }}
              </a>
            </ProvideApiFetch>
          </div>
        </WdsMenu>
        <WdsButton
          tertiary
          rounded
          aria-controls="main-menu"
          :aria-expanded="isExpanded(type)"
          aria-label="Toggle sidebar"
          class="menu-button"
          @click="toggleSidebar(type)"
        >
          <WdsIcon :size="16" name="menu"></WdsIcon>
        </WdsButton>
      </WdsStack>
    </div>
  </header>
</template>

<script>
import {
  WdsStack,
  WdsIcon,
  WdsButton,
  WdsButtonGhost,
  WdsMenu,
  WdsBadge,
} from '@worksome/wds-components'
import { APP_NAVIGATION } from '@/state/mutation-types'
import ProvideApiFetch from '@/components/ProvideApiFetch.vue'

export default {
  components: { WdsButton, WdsButtonGhost, WdsStack, WdsIcon, WdsMenu, WdsBadge, ProvideApiFetch },
  props: {
    initialNotificationCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      notificationCount: this.initialNotificationCount,
    }
  },
  methods: {
    isExpanded(type) {
      return type === 'desktop'
        ? this.$store.state.navigation.isSideBarOpenDesktop
        : this.$store.state.navigation.isSideBarOpen
    },
    toggleSidebar(type) {
      const mutation =
        type === 'desktop'
          ? APP_NAVIGATION.TOGGLE_DESKTOP_SIDEBAR_OPEN_STATE
          : APP_NAVIGATION.TOGGLE_SIDEBAR_OPEN_STATE
      this.$store.commit(mutation)
    },
  },
}
</script>

<style scoped lang="scss">
.mobile-menu {
  @media (min-width: 1280px) {
    display: none;
  }
}
.desktop-menu {
  @media (max-width: 1279px) {
    display: none;
  }

  // Hidden while the sidebar is open on desktop; the placeholder marks the pages that have one.
  @media (min-width: 1280px) {
    body:has(#sidebar-placeholder:not(.hidden)) & {
      display: none;
    }
  }
}
.menu {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  border-radius: 9999px;
  margin: 20px;
  margin-top: 15px;
  // Above the page overlay (.page-overlay, z-20), below WDS modals (2999): this pill is the only way to reopen a collapsed sidebar.
  z-index: 21;
  background-color: white;
  padding: 8px 12px;
  gap: 8px;
  box-shadow: 0px 8px 12px 0px #090d3014;
}
.menu-button {
  padding: 6px;
}
</style>
